<template>
    <div>
        <PartnersPageIntro
            v-if="collectionsNames"
            :collections-names="collectionsNames"
            art-alternative-text="Galeria de Artistas"
            title="O que é o projeto Galeria de Artistas?"
        >
            <p>
                Este projeto foi criado com o objetivo de construir uma galeria de talentos
                selecionados e convidados. Fizemos um trabalho de curadoria em busca de artistas que
                admiramos e acreditamos na sinergia com a Chico Rei. Temos certeza que a arte toca e
                torna o intangível uma presença e tanto na vida das pessoas, por isso oferecemos um
                espaço para que possam oferecer a seu público produtos diferenciados com sua arte e
                com ganhos financeiros reais.
            </p>
            <p>
                Acreditamos que é feito queijo e goiabada! Você traz seu trabalho pra cá, ganha um
                espaço pra construir sua lojinha e nós cuidamos do resto pra você.
            </p>
            <p>
                Com nossa expertise de 10 anos, oferecemos produtos de alta qualidade, uma carteira
                qualificada de consumidores e um conceito de marca bem consolidado. Cuidamos de cada
                etapa da produção, desde o pedido até a entrega na casa do cliente. Além de sua arte
                encontrar uma comunidade gigante de criativos que já têm um relacionamento com a
                gente, você também terá acesso a um público novo e vai ter espaço para divulgar sua
                loja.
            </p>
        </PartnersPageIntro>

        <div class="medium-content">
            <PartnersPageBlock title="Mas como funciona?">
                <PartnersPageBenefits :items="instructions" />
            </PartnersPageBlock>

            <PartnersPageBlock title="Por que trazer sua arte pra cá?">
                <PartnersPageBenefits :items="benefits" />
            </PartnersPageBlock>
        </div>

        <div v-if="(depositions || []).length" class="medium-content">
            <PartnersPageBlock title="Gente fina e talentosa que manda bem na galeria">
                <PartnersPageDeposition
                    v-for="(deposition, index) in depositions"
                    :key="index"
                    :deposition="deposition"
                />
            </PartnersPageBlock>
        </div>

        <div class="medium-content">
            <PartnersPageBlock title="Alguns números irados">
                <PartnersPageAchievements :achievements="achievements" />
            </PartnersPageBlock>

            <PartnersPageBlock :framed="true" title="Topa fazer arte com a gente?">
                <PartnersPageForm :partner-type-id="2" class="mt" />
            </PartnersPageBlock>
        </div>
    </div>
</template>

<script>
    import PartnersPageIntro from './PartnersPageIntro';
    import { partnerService } from '../../../../common/service/resource';
    import PartnersPageBenefits from './PartnersPageBenefits';
    import PartnersPageDeposition from './PartnersPageDeposition';
    import PartnersPageAchievements from './PartnersPageAchievements';
    import PartnersPageForm from './PartnersPageForm';
    import PartnersPageBlock from './PartnersPageBlock';

    export default {
        el: '#partnership-vue',

        name: 'PartnersArtistsPage',

        components: {
            PartnersPageBlock,
            PartnersPageForm,
            PartnersPageAchievements,
            PartnersPageDeposition,
            PartnersPageBenefits,
            PartnersPageIntro,
        },

        data() {
            return {
                collectionsNames: null,
                depositions: null,
                instructions: [
                    {
                        image: 'instrucoes-01.svg',
                        text: 'Você faz uma seleção de artes que considera bacanas e envia pra gente. As artes não precisam ser novas, mas não podem ser vendidas simultaneamente por qualquer outra loja nacional.',
                    },
                    {
                        image: 'instrucoes-02.svg',
                        text: 'Feito isso, elas serão revisadas pelo nosso time de Criação e Marketing, assim poderemos retornar com dicas legais que ajudem a potencializar suas vendas. ',
                    },
                    {
                        image: 'instrucoes-03.svg',
                        text: 'Assim que as artes forem aprovadas, faremos as adaptações para nosso mix de produtos: camisetas, canecas, posters, capas para celular, almofadas, sketchbooks e outros produtos novos que podem pintar por aí. Adoramos novas ideias e sugestões!',
                    },
                    {
                        image: 'instrucoes-04.svg',
                        text: 'Os produtos ficarão disponíveis para venda em uma página personalizada, onde você expõe também um pouco sobre o seu trabalho. Além da página de vendas, será feita uma outra página reunindo conteúdo sobre o seu trabalho, como fotos, entrevistas, rascunhos e o que mais achar interessante. Esse trabalho será feito por nossa equipe de Comunicação em contato direto com você.',
                    },
                    {
                        image: 'instrucoes-05.svg',
                        text: 'Você terá acesso a um painel superbacana onde poderá conferir o desempenho de vendas de seus produtos, sua comissão e demais informações que ajudem na melhoria contínua de nossa parceria.',
                    },
                    {
                        image: 'instrucoes-06.svg',
                        text: 'A coleção será divulgada nas redes sociais da Chico Rei. Todo esse material de divulgação será criado pela nossa equipe, contando com sua consultoria. Vale lembrar que o sucesso da parceria depende do esforço contínuo de ambas as partes: quanto mais gente ficar sabendo, mais vendas garantidas',
                    },
                ],
                benefits: [
                    {
                        image: 'vantagens-infraestrutura.svg',
                        title: 'Infraestrutura',
                        text: 'A gente cuida de tudo! Fornecemos um hotsite completo, um para contar um pouco mais sobre você e seu trabalho; outro para estabelecer a sua loja. Você passa as informações  a gente constrói espaços com a sua cara.',
                    },
                    {
                        image: 'vantagens-público.svg',
                        title: 'Público qualificado',
                        text: 'Temos centenas de milhares de cadastros ativos. As pessoas que entram no site da Chico Rei estão buscando produtos criativos com diversas temáticas e você terá sua arte imersa nessa comunidade enorme e engajada.',
                    },
                    {
                        image: 'vantagens-líder.svg',
                        title: 'Líder no segmento',
                        text: 'A Chico Rei é referência no mercado online quando se fala de produtos e estampas criativas. Vestimos personalidades que se destacam e temos grandes marcas ao nosso lado.',
                    },
                    {
                        image: 'vantagens-transparência.svg',
                        title: 'Transparência',
                        text: 'Quando você vende no nosso site, tem acesso a um painel completo para o acompanhamento das vendas. Lá você consegue acompanhar as transações em tempo real, produto a produto. Você pode se planejar e produzir conteúdo de acordo com a demanda do público.',
                    },
                    {
                        image: 'vantagens-rentabilidade.svg',
                        title: 'Rentabilidade',
                        text: 'Independente do valor vendido, você recebe sua comissão no mês subsequente ao das vendas. Temos um compromisso com o sucesso da lojinha, estamos sempre disponíveis para o planejamento de divulgação, seleção de temáticas e práticas que auxiliem a potencializar a demanda.',
                    },
                    {
                        image: 'vantagens-relacionamento.svg',
                        title: 'Relacionamento',
                        text: 'Queremos ver a comunidade artística independente se tornar cada vez mais forte e por isso temos sempre alguém à disposição pra te ajudar. Nosso time pode dar pitaco nas temáticas mais vendidas e nas melhores formas de divulgar sua coleção.',
                    },
                ],
                achievements: [
                    'Mais de 1 milhão de produtos criativos desenvolvidos',
                    'Cerca de 3000 estampas inéditas criadas pela nossa equipe',
                    'Mais de 30 mil litros de café consumidos',
                    'Mais de 1 milhão de seguidores nas redes sociais',
                    'Média de 300 mil acessos mensais',
                    'Centenas de milhares de clientes espalhados em mais de 3.800 cidades no Brasil, além de mais 30 países mundo afora.',
                ],
            };
        },

        created() {
            this.fetchCollections();
        },

        methods: {
            fetchCollections() {
                partnerService
                    .query({ partner_type_id: 2 })
                    .then((response) => {
                        this.collectionsNames = response.data.map((a) => a.name);
                        this.depositions = response.data
                            .filter((partner) => partner.testimonial)
                            .slice(0, 5)
                            .map((partner) => ({
                                name: partner.name,
                                text: partner.testimonial.split('\\n'),
                                author: partner.testimonial_author,
                                productsLink: partner.catalog_url,
                            }));
                    })
                    .catch((e) => {
                        this.errorLoading = true;
                    })
                    .then(() => (this.loading = false));
            },
        },
    };
</script>
